import { call, put, select } from 'redux-saga/effects';

import api from 'api';
import { IRotatedAuthTokensResponse } from 'api/components/Auth/types';
import { setAccessRefreshTokens } from 'api/utils/tokenManagement';

import { notifyError } from 'store/notifications/actions';
import { getUserFeatures } from 'store/user/actions';
import { selectCurrentUser } from 'store/user/selectors';
import { UserStore } from 'store/user/types';

import { Provider } from 'services/Analytics/core';
import sentry from 'services/Sentry/SentryInstance';

import { setAuthenticationStatus, signInError, signInRequest, signInSuccess } from '../actions';

import { getWFTokenForWebPlatform, waitForGetCurrentUser } from './helpers';

export function* signInSaga({ payload }: ReturnType<typeof signInRequest>) {
    const { userData, onSuccess, onError } = payload;

    try {
        const { access, refresh }: IRotatedAuthTokensResponse = yield call(api.auth.signIn, userData);

        yield call(setAccessRefreshTokens, { access, refresh });

        try {
            yield call(waitForGetCurrentUser);

            const userDataResponse: UserStore = yield select(selectCurrentUser);

            yield call(getWFTokenForWebPlatform);

            yield put(getUserFeatures());
            yield put(setAuthenticationStatus(true));
            yield put(signInSuccess());

            const getCountry = async (): Promise<string | null> => {
                return new Promise((resolve) => {
                    resolve(userDataResponse.country);
                });
            };

            Provider.provideData({
                country: async () => await getCountry(),
            });

            onSuccess();
        } catch (error: any) {
            onError();
            sentry.sentrySagaLog(error, 'signInSaga');
        }
    } catch (error: any) {
        const status = error.response?.status;
        const data = error.response?.data;

        const isIncorrectCode = [400, 401, 429].includes(error.response?.status);

        if (!isIncorrectCode) {
            yield put(notifyError({ message: 'message.error.somethingWentWrong' }));
            sentry.sentrySagaLog(error, 'signInSaga');
        }

        yield put(signInError());

        onError(status, data);
    }
}
